"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkoutReviewCreator = void 0;
var consts_1 = require("../consts");
var checkoutReviewCreator = function (event) {
    var eventData = {
        action: "checkout-review",
        event: "checkout-review-load",
        eventInfo: "checkout-review-load",
        cart: {
            product: event.eventData.cart.product.map(function (item) { return (__assign(__assign({}, item), { bundledProduct: item.bundledProduct || consts_1.NOT_AVAILABLE })); })
        },
    };
    return eventData;
};
exports.checkoutReviewCreator = checkoutReviewCreator;
